export class Winery {
    id: number;
    name: string;
	active: boolean;
    sort_order: number;
    alias: string;
	
	description_nl: string;
	
	description_en: string;
	
	description_fr: string;
	
	description_de: string;
	
	created_at: string;
    updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/winery.ts